/**
 * mydea product grid pager — pagina 4 prodotti alla volta con frecce
 */
(function () {
  const PER_PAGE = 4;

  function init() {
    const section = document.querySelector('[id*="product_list_YidTcf"]');
    if (!section) return;

    const items = Array.from(section.querySelectorAll('.resource-list__item'));
    if (items.length <= PER_PAGE) return;

    let page = 0;
    const totalPages = Math.ceil(items.length / PER_PAGE);

    function render() {
      items.forEach((el, i) => {
        el.style.display = (i >= page * PER_PAGE && i < (page + 1) * PER_PAGE) ? '' : 'none';
      });
      prevBtn.style.opacity = page === 0 ? '0.25' : '1';
      prevBtn.style.pointerEvents = page === 0 ? 'none' : '';
      nextBtn.style.opacity = page === totalPages - 1 ? '0.25' : '1';
      nextBtn.style.pointerEvents = page === totalPages - 1 ? 'none' : '';
      counter.textContent = (page + 1) + ' / ' + totalPages;
    }

    const controls = document.createElement('div');
    controls.className = 'mydea-pager';
    controls.innerHTML =
      '<button class="mydea-pager__btn" id="mydea-prev" aria-label="Precedente">' +
        '<svg width="18" height="18" viewBox="0 0 20 20" fill="none">' +
          '<path d="M15.75 10H4.25m0 0 4 4m-4-4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
      '</button>' +
      '<span class="mydea-pager__counter"></span>' +
      '<button class="mydea-pager__btn" id="mydea-next" aria-label="Successiva">' +
        '<svg width="18" height="18" viewBox="0 0 20 20" fill="none">' +
          '<path d="M4.25 10h11.5m0 0-4-4m4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
      '</button>';

    const grid = section.querySelector('[data-testid="resource-list-grid"]');
    grid.after(controls);

    const prevBtn = document.getElementById('mydea-prev');
    const nextBtn = document.getElementById('mydea-next');
    const counter = controls.querySelector('.mydea-pager__counter');

    prevBtn.addEventListener('click', function () { page--; render(); });
    nextBtn.addEventListener('click', function () { page++; render(); });

    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
